export default __webpack_public_path__ + "static/media/bird.8a57546f.svg";